// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1505":"css/app.6904","5259":"css/admin-app.6904"}[chunkId] + ".css";
};